import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Contract from "../Pages/User/Contract";
import Welcome from "../Pages/User/Welcome";
import ThankYou from "../Pages/User/ThankYou";
import BadgeForm from "../Pages/User/Badge";

const UserRoutes = () => {
  return (
    <Routes>
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/contract/:id" element={<Contract />} />
      <Route path="/contract/:id/thank-you" element={<ThankYou />} />
      <Route path="/badges/:vendorCode" element={<BadgeForm />} />
      <Route path="*" element={<Navigate to={"/welcome"} />} />
    </Routes>
  );
};

export default UserRoutes;